import React from "react";
import { Checkbox } from "antd";
import { RightOutlined, PlayCircleFilled } from "@ant-design/icons";
import MediaFetcher from "../library/MediaFetcher";
import { formatDate } from "../utils.js";

const CreativeListRow = ({ media, selected, onSelect, onClick, isVideo }) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect(media.id);
  };

  const dimensions = media.width && media.height
    ? `${media.width}x${media.height}`
    : null;

  return (
    <div
      className={`creative-card-row${selected ? " creative-card-row--selected" : ""}`}
      onClick={() => onClick(media)}
    >
      <div className="creative-card-row__checkbox">
        <Checkbox
          checked={selected}
          onClick={handleCheckboxClick}
        />
      </div>

      <div className="creative-card-row__thumbnail">
        {media.key ? (
          <MediaFetcher
            mediaKey={media.key}
            width="100%"
            height="100%"
            objectFit="cover"
          />
        ) : (
          <div className="creative-card-row__placeholder">?</div>
        )}
        {isVideo && (
          <div className="creative-card-row__video-badge">
            <PlayCircleFilled />
          </div>
        )}
      </div>

      <div className="creative-card-row__content">
        <div className="creative-card-row__name" title={media.name}>
          {media.name || "Untitled"}
        </div>
        <div className="creative-card-row__meta">
          {[dimensions, media.mediaType, media.createdAt && formatDate(media.createdAt)]
            .filter(Boolean)
            .join(" \u00B7 ")}
        </div>
      </div>

      <div className="creative-card-row__chevron">
        <RightOutlined />
      </div>
    </div>
  );
};

export default CreativeListRow;
